import { React, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, InputGroup, OverlayTrigger, Tooltip,  Modal} from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import ServicesRequest from '../../../service/ServiceRequest'
import ReactLoading from "react-loading";
import Swal from 'sweetalert2'
import { ProductString } from '../../../constants/Product-Strings'
import { PublicStrings } from '../../../constants/Public-Strings'
import { successToast } from '../../../constants/Toasts-Components'
import { use } from 'react'





const EnabledUsersOrAgenciesList = ({ enabled_for, product_id, setEnabledFor}) => {

    const { config } = useSelector((state) => state.auth);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let serviceRequestObj = new ServicesRequest("product");

    const [all_products, setAllProducts] = useState([]);
    async function fetchAgencies(){
        let agencyServiceRequestObj = new ServicesRequest("agency");
        const response = await agencyServiceRequestObj.getProductListComplete();
        if(response && response.data){
            setAllProducts(response.data);
            console.log("agencies: ")
            console.log(response.data)
        }
    }
    useEffect(() => {
        fetchAgencies();
    }, [])

    return (
        <>        
            <Card className="smooth-transition">
                <Card.Body>

                    <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                        
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className="font-weight-bold">Prodotto abilitato per agenzie e utenti</h5>
                        </div>

                        <Button variant="primary" onClick={handleShow}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            Aggiungi
                        </Button>
                
                        <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Abilita Prodotto Per:</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                        <table className="table data-table mb-0">
                            <tbody>
                                {
                                        <>
                                            {
                                               enabled_for.length === all_products.length ? 
                                    
                                               <i> Questo prodotto è già abilitato per tutti gli utenti</i>
                                                : 

                                                all_products.map((item, index) => ( 

                                                    enabled_for.map(user  => user.pk).includes(item.id) ? "" :
                                                        <tr className="white-space-no-wrap" key={index}>

                                                            <td style={{"padding" : "0px" , "borderTop" : "1px"}}>
                                                                <div className="d-flex justify-content-end align-items-center">

                                                                        <button type="button" className="dropdown-item bg-light border rounded btn-block mb-2" onClick={async () => {
                                                                            
                                                                            const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(product_id, item.id, 'agency', true, 'product')
                                                                            if(response !== null){
                                                                                if(response.response){

                                                                                    Swal.fire({
                                                                                        icon: 'error',
                                                                                        title: 'Error',
                                                                                        text: response.response.data.error_message,
                                                                                    })
                                                                                } else{
                                                                                    console.log("Adding stuff");
                                                                                    handleClose();
                                                                                    console.log(enabled_for);
                                                                                    setEnabledFor(values => ([ ...values, item ]))
                                                                                }  
                                                                            }

                                                                        }}>
                                                                            

                                                                            {item.name}
                                                                        </button>
                                 

                                                                </div>
                                                            </td>
                                                         </tr>
                                                    

                                                ))
                                            }
                                        </>
                                }
                            </tbody>
                        </table>

                        </Modal.Body>
                        
                        </Modal>

                    </div>

                    
                    
                                
                                <>
                                {
                                    enabled_for.length === 0 ? 

                                        <i> Questo prodotto non è abilitato per nessun utente </i>
                                    :<table className="table data-table mb-0">
                                    <tbody>
                                          
                                        {enabled_for.map((item, index) => ( 
                                            
                                            <tr id={"enabled_row_"+item.id} key={index} className="white-space-no-wrap">

                                                <td> {item.name}</td>

                                                <td>
                                                    <div className="d-flex justify-content-end align-items-center">

                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Remove</Tooltip>} >
                                                            <h6 className="badge bg-danger" onClick={async () => {

                                                                const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(product_id, item.id, 'agency', false, 'product')
                                                                if(response !== null){
                                                                    if(response.response){

                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: response.response.data.error_message,
                                                                        })
                                                                    } else{
                                                                        console.log("Deleting stuff");
                                                                        setEnabledFor(values => (values.filter(f => f.id !== item.id)));
                                                                        var row = document.getElementById(`enabled_row_${item.id}`);
                                                                        row.remove();
                                                                    }  
                                                                }

                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                </svg>
                                                            </h6>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                        
                                    
                                }
                                </>
                            
                            
                        

                </Card.Body>
            </Card>

        </>
    )
}


const ProductAddOrView = (props) => {

    let serviceRequestObj = new ServicesRequest("product");

    const form = useRef(null);
    const history = useHistory();
    const { config } = useSelector((state) => state.auth)

    const [inputs, setInputs] = useState({
        name : '',
        type: '',
        contratto: '',
        impiego: '',
        opening_date : new Date().toISOString().split('T')[0],
        closing_date : null,
        rappel_produzione:100,
        over_produzione : 100,
        target_produzione : 0,
        is_renewable : false,
        renewal_notification_days : 30
    });

    const [enabled_for, setEnabledFor] = useState([]);
    const [loading, setLoading] = useState(false);
    const [is_renewable, setIsRenewable] = useState(false);
    const [all_agencies, setAllAgencies] = useState([]);
    const [is_new_product, setIsNewProduct] = useState(true)
    const [product_id, setProductId] = useState("");

    const params = useParams();

    async function fetchProductInfo(product_id) {

        setLoading(true);

        const response = await serviceRequestObj.getProductInfo(product_id);
        if (!response.response) {

            setIsRenewable(response['is_renewable']);
            setEnabledFor(response['enabled_for']);
            // console.log(response['enabled_for']);

            const columns = ['id', 'name', 'rappel_produzione', 'target_produzione',
                'over_produzione', 'opening_date', 'closing_date', 'is_renewable',
                'renewal_notification_days']

            // include new backend fields if present
            columns.push('type', 'contratto', 'impiego')

            for (const key of columns) {
                var value = response[key];
                if (value !== null) {
                    setInputs(values => ({ ...values, [key]: value }))
                }
            }
        }
        setLoading(false);
    }

    async function fetchAgencies(){
        let agencyServiceRequestObj = new ServicesRequest("agency");
        const response = await agencyServiceRequestObj.getProductListComplete();
        console.log("agencies: ")
        console.log(response);
        if(!response){
            setAllAgencies(response.data);
        }
    }

    useEffect(() => {

        //console.log("Product id: "+params.product_id + " ", isNaN(params.product_id), params.product_id === null)
        setProductId(params.product_id);
        setIsNewProduct(isNaN(params.product_id));

        if (params.product_id) {
            fetchProductInfo(params.product_id);
            fetchAgencies();
        }

    }, [])




    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }))
    }

    const handleSwitchChange = (event) => {

        const name = event.target.name;
        const value = event.target.checked;
        setInputs(values => ({ ...values, [name]: value }))
    }

    const handleIsRenewableToggle = (event) => {

        setIsRenewable(event.target.checked);
        //setInputs(values => ({ ...values, ["is_renewable"]: event.target.checked }));

        if (!event.target.checked) {
            const inputs_copy = { ...inputs };
            delete inputs_copy['renewal_notification_days'];
            setInputs(inputs_copy);
        }

        handleSwitchChange(event)
    }

    const submitCreateProduct = async (event) => {

        event.preventDefault();
        setLoading(true);
        const response = await serviceRequestObj.createProduct(inputs);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            setProductId(response.id);
            setIsNewProduct(false);
            setInputs(values => ({ ...values, "id": response.id }))
            setEnabledFor(response.enabled_for)
            const editUrl = "/product-view/" + response.id;
            window.history.replaceState(null, "", editUrl);
            successToast('Product Added Successfully..')
        }
        setLoading(false)
        
    }


    const submitSaveProduct = async (event) => {
        event.preventDefault();
        setLoading(true);
        const response = await serviceRequestObj.saveProduct(inputs);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            successToast('Update Successfully..')
        }
        setLoading(false)
    }


    return (
        <>
            <Container fluid className='smooth-transition'>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb p-0 mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={{ pathname: "/product", state: {}}}> {ProductString.title} </Link>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page">{is_new_product ? ProductString.addProduct : (config.is_admin? 'Modifica Prodotto' : 'Visualizza Prodotto') }</li>
                                    </ol>
                                </nav>
                            </div>
                            <Link to={{ pathname: "/product", state: {}}} className="btn btn-primary btn-sm d-flex align-items-center justify-content-between ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                </svg>
                                <span className="ml-2">{PublicStrings.back}</span>
                            </Link>
                        </div>
                    </Col>
                    <Col lg="12" className="mb-3 d-flex justify-content-between">
                        <h4 className="font-weight-bold d-flex align-items-center">{is_new_product ? 'Aggiungi Prodotto' : (config.is_admin? 'Modifica Prodotto' : 'Visualizza Prodotto')}</h4>
                    </Col>
                    <Col lg="12">
                        <Card>
                            <Card.Body className="smooth-transition">
                                {loading && is_new_product === false ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                                        <ReactLoading
                                            type={"spin"}
                                            color={"#007bff"}
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                <Form className=" g-3" onSubmit={is_new_product ? submitCreateProduct : submitSaveProduct} ref={form}>
                                    <div className='row'>

                                        <Form.Control type='text' name='id' defaultValue={product_id} hidden />

                                        <div className="col-md-6 mb-3" key="1">
                                            <Form.Label htmlFor='name' className="form-label font-weight-bold text-muted text-uppercase">{ProductString.name}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='name' placeholder=''
                                                maxLength="30"
                                                defaultValue={""}
                                                value={inputs["name"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>



                                        <div className="col-md-6 mb-3" key="type">
                                            <Form.Label htmlFor='type' className="form-label font-weight-bold text-muted text-uppercase">Tipo</Form.Label>
                                            <Form.Control as='select' className="form-control" name='type'
                                                value={inputs['type'] || ''}
                                                onChange={(e)=>handleChange(e)}
                                                disabled={!config.is_admin}
                                            >
                                                <option value="">Seleziona prodotto</option>
                                                <option value="cessione parapubblica dipendente">cessione parapubblica dipendente</option>
                                                <option value="cessione privato dipendente">cessione privato dipendente</option>
                                                <option value="cessione privato dipendente az. affidata">cessione privato dipendente az. affidata</option>
                                                <option value="cessione privato dipendente coop&lt;150 dip-cf">cessione privato dipendente coop&lt;150 dip-cf</option>
                                                <option value="cessione privato dipendente small - no tfr">cessione privato dipendente small - no tfr</option>
                                                <option value="cessione pubblico dipendente">cessione pubblico dipendente</option>
                                                <option value="cessione pubblico pensionato altro">cessione pubblico pensionato altro</option>
                                                <option value="cessione pubblico pensionato inpdap">cessione pubblico pensionato inpdap</option>
                                                <option value="cessione pubblico pensionato inps">cessione pubblico pensionato inps</option>
                                                <option value="cessione statale dipendente">cessione statale dipendente</option>
                                                <option value="delega parapubblica dipendente">delega parapubblica dipendente</option>
                                                <option value="delega privato dipendente">delega privato dipendente</option>
                                                <option value="delega pubblico dipendente">delega pubblico dipendente</option>
                                                <option value="delega statale dipendente">delega statale dipendente</option>
                                            </Form.Control>
                                        </div>

                                        <div className="col-md-6 mb-3" key="contratto">
                                            <Form.Label htmlFor='contratto' className="form-label font-weight-bold text-muted text-uppercase">Contratto</Form.Label>
                                            <Form.Control as='select' className="form-control" name='contratto'
                                                value={inputs['contratto'] || ''}
                                                onChange={(e)=>handleChange(e)}
                                                disabled={!config.is_admin}
                                            >
                                                <option value="">Seleziona contratto</option>
                                                <option value="004">Delega</option>
                                                <option value="001">Cessione</option>
                                            </Form.Control>
                                        </div>

                                        <div className="col-md-6 mb-3" key="impiego">
                                            <Form.Label htmlFor='impiego' className="form-label font-weight-bold text-muted text-uppercase">Impiego</Form.Label>
                                            <Form.Control as='select' className="form-control" name='impiego'
                                                value={inputs['impiego'] || ''}
                                                onChange={(e)=>handleChange(e)}
                                                disabled={!config.is_admin}
                                            >
                                                <option value="">Seleziona impiego</option>
                                                <option value="PRI">Privato</option>
                                                <option value="PUB">Pubblico</option>
                                                <option value="PAR">Parapubblico</option>
                                                <option value="STA">Statale</option>
                                            </Form.Control>
                                        </div>


                                        <div className="col-md-6 mb-3" key="7">
                                            <Form.Label htmlFor='opening_date' className="form-label font-weight-bold text-muted text-uppercase">{ProductString.opening_date}</Form.Label>
                                            <Form.Control type="date" className="form-control" name='opening_date' placeholder=''
                                                value={inputs[`opening_date`] ? inputs[`opening_date`] : new Date().toISOString().split('T')[0]}
                                                onChange={(e)=>handleChange(e)}
                                                required={true}
                                                disabled={!config.is_admin}
                                            />

                                        </div>


                                        <div className="col-md-6 mb-3" key="8">
                                            <Form.Label htmlFor='closing_date' className="form-label font-weight-bold text-muted text-uppercase">{ProductString.closing_date}</Form.Label>
                                            <Form.Control type="date" className="form-control" name='closing_date' placeholder=''
                                                value={inputs[`closing_date`] ? inputs[`closing_date`] : ""}
                                                onChange={(e)=>handleChange(e)}
                                                required={false}
                                                disabled={!config.is_admin}
                                            />
                                        </div>


                                        <div className="col-md-4 mb-3" key="4">

                                            <Form.Label htmlFor='rappel_produzione' className="form-label font-weight-bold text-muted text-uppercase">Rappel sulla Produzione</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
                                                <Form.Control type="number" name='rappel_produzione' placeholder=''
                                                    value={inputs['rappel_produzione']}
                                                    onChange={(e)=>handleChange(e)}
                                                    required={false}
                                                    min={0} max={100}
                                                    defaultValue={0}
                                                    disabled={!config.is_admin}
                                                />
                                            </InputGroup>
                                        </div>


                                        <div className="col-md-4 mb-3" key="6">
                                            <Form.Label htmlFor='over_produzione' className="form-label font-weight-bold text-muted text-uppercase">Over sulla Produzione</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
                                                <Form.Control type="number" name='over_produzione' placeholder=''
                                                    value={inputs['over_produzione']}
                                                    onChange={(e)=>handleChange(e)}
                                                    required={false}
                                                    min={0} max={100}
                                                    defaultValue={0}
                                                    disabled={!config.is_admin}
                                                />
                                            </InputGroup>
                                        </div>

                                        <div className="col-md-4 mb-3" key="5">
                                            <Form.Label htmlFor='target_produzione' className="form-label font-weight-bold text-muted text-uppercase">Target Produzione</Form.Label>
                                            <Form.Control type='number' className="form-control" name='target_produzione' placeholder=''
                                                value={inputs[`target_produzione`]}
                                                onChange={(e)=>handleChange(e)}
                                                required={false}
                                                defaultValue={0}
                                                disabled={!config.is_admin}

                                            />
                                        </div>


                                        <div className="col-md-6 mb-3" key="7.5"></div>


                                        <div className="col-md-12 mb-3" key="10">

                                            <Row>

                                                <div className="col-md-4 mb-3">
                                                    <Form.Label htmlFor='is_renewable' className="form-label font-weight-bold text-muted text-uppercase">Rinnovabile</Form.Label>
                                                    <Form.Check
                                                        type="switch"
                                                        name='is_renewable'
                                                        id="custom-switch"
                                                        checked={inputs[`is_renewable`] ? true : false}
                                                        onChange={handleIsRenewableToggle}
                                                        disabled={!config.is_admin}
                                                    />
                                                </div>

                                                <div className="col-md-6 mb-3" hidden={!is_renewable}>
                                                    <Form.Label htmlFor='renewal_notification_days' className="form-label font-weight-bold text-muted text-uppercase">Notifica di rinnovo (Giorni prima della scadenza)</Form.Label>
                                                    <Form.Control step={0} precision={0} type="number" className="form-control" name='renewal_notification_days' placeholder=''
                                                        value={inputs[`renewal_notification_days`] ? inputs[`renewal_notification_days`] : ""}
                                                        onChange={(e)=>handleChange(e)}
                                                        required={is_renewable}
                                                        disabled={!config.is_admin}
                                                    />
                                                </div>

                                            </Row>

                                        </div>








                                        {/* {
                                            data.map((e, index) =>
                                                <div className="col-md-6 mb-3" key={index}>
                                                    <Form.Label htmlFor={e.db_name} className="form-label font-weight-bold text-muted text-uppercase">{e.name}</Form.Label>
                                                    {
                                                        e.type === 'text' ?
                                                            <Form.Control type={e.type} className="form-control" name={e.db_name} placeholder={e.default != null ? e.default : ""}
                                                                value={inputs[`${e.db_name}`]}
                                                                onChange={handleChange}
                                                                required={e.required}

                                                            /> : ''
                                                    }
                                                    {
                                                        e.type === 'number' ?
                                                            <Form.Control type={e.type} className="form-control" name={e.db_name} placeholder={e.default != null ? e.default : ""}
                                                                value={inputs[`${e.db_name}`]}
                                                                onChange={handleChange}
                                                                required={e.required}

                                                            /> : ''
                                                    }
                                                    {
                                                        e.type === 'percentage' ?
                                                            <InputGroup>
                                                                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
                                                                <Form.Control type="number" name={e.db_name} placeholder={e.default != null ? e.default : ""}
                                                                    value={inputs[`${e.db_name}`]}
                                                                    onChange={handleChange}
                                                                    required={e.required}
                                                                    min={0} max={100}


                                                                />
                                                            </InputGroup>
                                                            : ''
                                                    }
                                                    {
                                                        e.type === 'datetime' ?
                                                            <Form.Control type="date" className="form-control" name={e.db_name} placeholder={e.default != null ? e.default : ""}
                                                                value={inputs[`${e.db_name}`]}
                                                                onChange={handleChange}
                                                                required={e.required}

                                                            /> : ''
                                                    }
                                                    {
                                                        e.type === 'bool' ?
                                                            <Form.Check
                                                                type="switch"
                                                                name={e.db_name}
                                                                id="custom-switch"
                                                                // checked={e.default !== null ? e.default : false}
                                                                onChange={handleSwitchChange}

                                                            // required={e.required}
                                                            /> : ''
                                                    }
                                                    {
                                                        e.type === 'int' ?
                                                            <Form.Control step={0} precision={0} type="number" className="form-control" name={e.db_name} placeholder={e.default != null ? e.default : ""}
                                                                value={inputs[`${e.db_name}`]}
                                                                onChange={handleChange}
                                                                required={e.required}

                                                            /> : ''
                                                    }
                                                    {
                                                        e.type === 'float' ?
                                                            <Form.Control step={0.1} precision={2} type="number" className="form-control" name={e.db_name} placeholder={e.default != null ? e.default : ""}
                                                                value={inputs[`${e.db_name}`]}
                                                                onChange={handleChange}
                                                                required={e.required}

                                                            /> : ''
                                                    }
                                                </div>
                                            )
                                        } */}

                                    </div>
                                    {   
                                        !config.is_admin ?  "" :
                                            (
                                                loading ? 
                                                    <Button type="button" disabled><ReactLoading
                                                        className="mx-auto"
                                                        type={"spin"}
                                                        color={"#fefefe"}
                                                        height={24}
                                                        width={24}
                                                    /></Button> 
                                                : 
                                                <Button type="submit">{is_new_product ? PublicStrings.add : PublicStrings.save}</Button>
                                            )

                                    }

                                    


                                </Form>
                                )}
                            </Card.Body>
                        </Card>
                        
                        { !config.is_admin ? "" :  
                            <div hidden={is_new_product} className="col-md-6" style={{ "paddingLeft": "0px" }}>
                                <EnabledUsersOrAgenciesList
                                    enabled_for = {enabled_for}
                                    product_id = {product_id}
                                    setEnabledFor = {setEnabledFor}
                                    all_products={all_agencies}
                                ></EnabledUsersOrAgenciesList>
                            </div> 
                          
                        }

                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default ProductAddOrView;